import type { ReactNode, HTMLAttributes } from 'react';
import styles from './TableCell.module.css';

export type TableCellAlign = 'left' | 'center' | 'right';
export type TableCellVariant = 'default' | 'success' | 'warning' | 'error' | 'info';

export interface TableCellProps extends HTMLAttributes<HTMLTableCellElement> {
  children: ReactNode;
  align?: TableCellAlign;
  variant?: TableCellVariant;
  isMasked?: boolean;
  as?: 'td' | 'th';
}

export function TableCell({
  children,
  align = 'left',
  variant = 'default',
  isMasked = false,
  as: Component = 'td',
  className,
  ...props
}: TableCellProps) {
  const classes = [
    styles.cell,
    styles[align],
    variant !== 'default' && styles[variant],
    isMasked && styles.masked,
    className,
  ].filter(Boolean).join(' ');

  return (
    <Component className={classes} {...props}>
      {children}
    </Component>
  );
}

TableCell.displayName = 'TableCell';
